import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="accept-terms"
export default class extends Controller {
  static targets = ['checkbox', 'submit']

  connect() {
    this.checkboxTarget.addEventListener('change', () => {
      this.submitTarget.disabled = !this.checkboxTarget.checked
      this.submitTarget.classList.toggle('disabled')
    });
  }
}
